/**!
 *  Overview of skill-building activities.
 */

import React, {useState} from 'react'
import styles from './skillBuilding.module.scss'

import Button from 'Components/UI/Button'
import List from './list'

const TabOverview = ({community = 0, message, onClose, onCreate, onDelete, onEdit}) =>
{
    const [loading, setLoading] = useState(false)
    const [selected, setSelected] = useState(null)

    const onSelect = (item) => setSelected(item.id === selected?.id ? null : item)

    return (
        <>
            <div className={styles.tab}>
                <h2>Technical Skills</h2>
                <List
                    community={community}
                    loading={loading}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onLoading={setLoading}
                    onSelect={onSelect}
                    selected={selected}
                />
            </div>
            <div className={styles.tray}>
                <Button
                    disabled={loading}
                    label="Create new"
                    onClick={onCreate}
                />
                <Button
                    disabled={loading || selected === null}
                    hollow={true}
                    label="Edit selected"
                    loading={loading}
                    onClick={() => onEdit(selected)}
                />
                <Button
                    hollow={true}
                    label="Close"
                    onClick={onClose}
                />
                {message && <div className={styles.message}>{message}</div>}
            </div>
        </>
    )
}

export default TabOverview